import React from "react"

function IconMobile({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="mobile"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-mobile"
      {...props}
    >
      <path
        d="M16.364 2.618c.91 0 1.658.697 1.738 1.587l.007.159v15.272c0 .91-.697 1.658-1.586 1.739l-.16.007H7.637c-.91 0-1.658-.697-1.738-1.587l-.007-.159V4.364c0-.91.697-1.658 1.586-1.739l.16-.007h8.727zm0 1.31-2.182-.002v.438a.545.545 0 0 1-.546.545h-3.272a.545.545 0 0 1-.546-.545v-.438l-2.182.001c-.21 0-.386.15-.427.349l-.009.088v15.272c0 .211.15.387.348.428l.088.009h8.728c.21 0 .386-.15.427-.349l.009-.088V4.364c0-.211-.15-.387-.348-.428l-.088-.009z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconMobile
